module.exports = __webpack_public_path__ + "static/media/esports-page-grid-3.a42d9d2d.jpg";